import React, {forwardRef, useEffect, useImperativeHandle, useMemo, useState} from 'react';
import {useDebounce} from 'ahooks';
import {Tabs} from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import RightChartTab from '@/pages/datalab/pages/WorkBench/components/RightModal/RightChartTab';
import RightLayoutTab from './RightLayoutTab';
import { COMPONENT_CONFIG } from '@dbl/core/chartEditor';
import {AI_ANALYSIS_TYPE} from '@dbl/core/dashboard';
import {useDblIntl} from '@/pages/datalab/utils/utils';
// 旧版本（保留以便回退）
// import Filter from './ExitModal/Filter';
// 新版本
import EditFilter from './ExitModal/EditFilter';
import Text from './ExitModal/EditText/Text';

import {chartListItemType} from '../../CreateReport/_type';
import './index.scss';
import {useTokenFailureSetSessionCache} from '../../../Multidimensional/Analysis';
import {ChangeTabLayoutsType} from "@dbl/core/dashboard";
import {useGetChartList} from "@/pages/datalab/pages/WorkBench/CreateReport/hooks";
import FullLoading from "@home/components/FullLoading";
import {GlobalPositioningGuidance} from "@/pages/datalab/pages/Home/GettingStart";
import {useIsShowGuide} from '../../../Home/hoooks';
import FilterSetUp from "@/pages/datalab/pages/WorkBench/components/RightModal/FilterSetUp";

const TAB_ID_CHARTS = 'charts';
const TAB_ID_ELES = 'layoutElements';

const RightModal = (props: any, ref) => {
  const { gameCode, changeRightModalDragItem, views, leftLayoutSelectItem, changeLeftLayoutSelectItem, handleOnSubmit, hasChartPrivilege, tabLayouts, changeTabLayoutsReduce, subType, filters, userFilter, enableCollapseFilter, showContact, changeShowContact, hasUserFilter } = props;
  const {isShowGuide} = useIsShowGuide();
  const isShowGuideLodaing = subType && isShowGuide;
  const [open, setOpen] = useState(true);  // 展开右侧栏
  const [selectedTab, setSelectedTab] = useState(TAB_ID_CHARTS); // 选择的tab
  const [searchValue, setSearchValue] = useState<string>(''); // 搜索值（用于显示，即时更新）
  const debouncedSearchValue = useDebounce(searchValue, { wait: 500 }); // 防抖后的搜索值（用于接口请求）
  const [sort, setSort] = useState<'asc' | 'desc'>('desc'); // 排序方式（用于显示，即时更新）
  const debouncedSort = useDebounce(sort, { wait: 300 }); // 防抖后的排序值（用于接口请求）
  const [onlyMyCharts, setOnlyMyCharts] = useState<boolean>(false); // 是否仅显示我的图表（用于显示，即时更新）
  const debouncedOnlyMyCharts = useDebounce(onlyMyCharts, { wait: 300 }); // 防抖后的仅显示我的图表值（用于接口请求）
  const { dblFormatMessage, isEn } = useDblIntl('create_dashboard');
  const tabs = useMemo(() => [
    {
      id: TAB_ID_CHARTS,
      label: dblFormatMessage('chart'),
    },
    {
      id: TAB_ID_ELES,
      label: dblFormatMessage('layout_elements'),
    }
  ], [isEn]);

  const { userFailureValue, takeEffect, handleOnSuccessCache } = useTokenFailureSetSessionCache(
    useMemo(() => ({ selectedTab, open }), [open, selectedTab]),
  );

  useImperativeHandle(ref, () => ({
    // 展开右侧栏
    openRightModal: () => {
      !open && setOpen(true);
    },
  }));

  useEffect(() => {
    if (takeEffect) {
      const { open, selectedTab } = userFailureValue || {};
      setSelectedTab(selectedTab);
      setOpen(open);
    }
  }, [takeEffect, userFailureValue]);
  
  const {
    chartData,
    chartLoading,
    chartError,
    hasMore: hasMoreCharts,
    loadMore: loadMoreCharts,
    firstLoading,
    loadingMore,
  } = useGetChartList(gameCode, 'datalab', [], undefined, () => {
    handleOnSuccessCache?.();
  }, debouncedSearchValue, debouncedSort, debouncedOnlyMyCharts);

  const {chartListData}: {chartListData: chartListItemType[];} = useMemo(() => {
    // const selectedIdList = views?.filter((v: any) => v?.chart_type)?.map((item: any) => String(item.task_id)) || [];
    const selectedIdList: string[] = [];
  
    // 所有tab页签下的图表
    tabLayouts?.forEach(({layouts}) => {
      layouts?.forEach(item => {
        item?.task_id && selectedIdList.push(String(item.task_id));
      });
      
    });
    
    // const viewList: any = [];
    
    // 过滤掉老数据，老数据的chartType为空
    // const chartDataArr = chartData?.data_list?.filter((item: any) => item.chart_type) || [];
    
    const chartListData = chartData?.data_list?.map(((item: any) => {
      const disable = selectedIdList?.includes(String(item?.task_id));
      // disable && viewList.push(item); // disable为true时, 说明是报表中的图表, 将图表列表中的数据赋值到viewList中, 用于筛选器设置模块的使用. 只所以不使用props.views里的图表数据, 是因为 如果用户更改了图表的类型, 名称之类的, props.views中图表数据不会跟随更新; 为了能获取最新的图表数据, 所以在这里加逻辑,从图表列表中获取图表的最新数据.
      
      
      // 返回的是图表列表的数据
      return {
        img: COMPONENT_CONFIG?.[item?.chart_type]?.icon,
        chartType: item?.chart_type,
        disable,
        ...item,
        title: isEn ? item?.name : (item?.name_cn || item?.name)
      };
    })) || [];
    return {chartListData};
  }, [chartData, views, isEn, tabLayouts]);
  
  const component = (() => {
    switch (leftLayoutSelectItem?.type) {
      case 'filter': {
        return (<EditFilter
          visible={true}
          initialFilter={leftLayoutSelectItem}
          viewList={views}
          existingFilters={filters}
          datasetList={[]} // 数据表列表从 viewList 中提取，在组件内部处理
          onConfirm={(filterConfig: any) => {
            changeTabLayoutsReduce?.(ChangeTabLayoutsType.UPDATE_FILTER, {
              filterInfo: {
                i: leftLayoutSelectItem.i,
                ...filterConfig,
              }
            });
            changeLeftLayoutSelectItem(null);
          }}
          onClose={() => {
            changeLeftLayoutSelectItem(null);
          }}
          gameCode={gameCode}
          system="datalab"
        />);
      }
      case 'userFilter': {
        return (<FilterSetUp
          gameCode={gameCode}
          chartList={views?.filter(
            item => item.chartType !== 'text' && item.chartType !== AI_ANALYSIS_TYPE,
          ) || []}
          generalFilters={filters}
          userFilter={userFilter}
          enableCollapseFilter={enableCollapseFilter}
          onConfirm={(config) => {
            const {showGeneralFilter, showUserFilter, showScope, scopeCharts, controls, enableCollapseFilter: nextEnableCollapseFilter} = config;
            if (showGeneralFilter !== (filters.length > 0)) { // 说明用户改变了 General Filter的展示状态
              changeTabLayoutsReduce?.(showGeneralFilter ? ChangeTabLayoutsType.ADD_FILTER : ChangeTabLayoutsType.CLEAR_FILTERS);
            }
            changeTabLayoutsReduce?.(ChangeTabLayoutsType.UPDATE_COLLAPSE_FILTER, { enableCollapseFilter: nextEnableCollapseFilter });
            if (showUserFilter) {
              // 用户开启时间对比
              if (userFilter.i) {
                // 说明已经 存在 user filter设置
                // 更新 user filter
                changeTabLayoutsReduce?.(ChangeTabLayoutsType.UPDATE_USER_FILTER, {showScope, scopeCharts, controls});
              } else {
                // 新建 user filter
                changeTabLayoutsReduce?.(ChangeTabLayoutsType.INIT_USER_FILTER, {showScope, scopeCharts});
              }
            } else { // 关闭用户时间对比
              changeTabLayoutsReduce?.(ChangeTabLayoutsType.DELETE_USER_FILTER);
            }
            changeLeftLayoutSelectItem(null);
          }}
          onClose={() => changeLeftLayoutSelectItem(null)}
        />);
      }
      case 'text': {
        return (<Text
          leftLayoutSelectItem={leftLayoutSelectItem}
          onConfirm={(value: any, isHidden) => {
            changeTabLayoutsReduce?.(ChangeTabLayoutsType.UPDATE_TEXT_CARD, {cardInfo: {i: leftLayoutSelectItem.i, ...value}});
            isHidden && changeLeftLayoutSelectItem(null);
          }}
          onClose={() => {
            changeLeftLayoutSelectItem(null);
          }}
        />);
      }
      default: {
        return (<>
          <Tabs
            className="dbl-right-modal-tabs"
            tabs={tabs}
            activeId={selectedTab}
            onActive={(tab: any) => setSelectedTab(tab.id)}
          />
          <div className="dbl-right-modal-content">
            {
              selectedTab === TAB_ID_CHARTS
                ? (
                  <RightChartTab
                    handleDragStart={changeRightModalDragItem}
                    chartListData={chartListData}
                    handleOnSubmit={handleOnSubmit}
                    loading={firstLoading}
                    error={chartError}
                    hasChartPrivilege={hasChartPrivilege}
                    hasMore={hasMoreCharts}
                    loadMore={loadMoreCharts}
                    loadingMore={loadingMore}
                    searchValue={searchValue}
                    onSearchChange={setSearchValue}
                    sort={sort}
                    onSortChange={setSort}
                    onlyMyCharts={onlyMyCharts}
                    onOnlyMyChartsChange={setOnlyMyCharts}
                  />
                )
                : <RightLayoutTab handleDragStart={changeRightModalDragItem}
                  disabledDragTabs={tabLayouts?.[0]?.tabId !== '-1'} changeShowContact={changeShowContact}
                  showContact={showContact} hasUserFilter={hasUserFilter}/>
            }
          </div>
        </>);
      }
    }
    
  })();
  return (<><div
    className={`dbl-right-modal ${!open ? 'dbl-right-modal-open' : ''}`}
    onTransitionEnd={(e: React.TransitionEvent) => {
      // 限制在该元素生效
      e.stopPropagation();
      // @ts-ignore
      if (e?.target?.className?.includes('dbl-right-modal')) {
        const resizeEvent = new Event('resize');
        window.dispatchEvent(resizeEvent);
      }
    }}
  >
    <div className="dbl-right-modal-box">
      { component }
    </div>
    <div
      className="dbl-right-modal-show"
      onClick={() => {
        setOpen(!open);
      }}
    >
      <SvgIcon type="arrow-right" className="dbl-right-modal-btnicon" />
    </div>
  </div>
  
  {/* subType有值代表是从首页跳转过来 要先展示加载态 */}
  {isShowGuideLodaing && chartLoading && <FullLoading />}
  {/* 图表列表加载完成后，才能获取到对应的指引为止的元素 */}
  { !chartLoading && <GlobalPositioningGuidance/> }
  
  </>);
};

export default forwardRef(RightModal);